export function getCsrfHeaders(): Record<string, string> {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? { "X-CSRF-Token": decodeURIComponent(match[1]) } : {};
}
